export const normalizeProductKey = (id) => {
  const asNumber = Number(id);
  return Number.isNaN(asNumber) ? id : asNumber;
};

export const getDiscountFinalValue = (value) => {
  if (typeof value === "undefined" || value === null) return NaN;
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.length === 0) return NaN;
    const normalized = trimmed.replace(",", ".");
    if (normalized.endsWith(".")) return NaN;
    const num = parseFloat(normalized);
    return Number.isNaN(num) ? NaN : num;
  }
  return NaN;
};

export const isValidDiscount = (value) => {
  const discount = getDiscountFinalValue(value);
  return typeof discount === "number" && Number.isFinite(discount) && discount > 0;
};

export const toFloat = (value, fallback = 0) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : fallback;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.length === 0) return fallback;
    const normalized = trimmed.replace(",", ".");
    const num = parseFloat(normalized);
    return Number.isFinite(num) ? num : fallback;
  }
  if (typeof value === "boolean") return value ? 1 : 0;
  if (value === null || typeof value === "undefined") return fallback;
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

export const getInvalidDiscountProducts = ({ cart, sconto, elementsMap, divisionNames, richiediDatiVendita }) => {
  if (!richiediDatiVendita) return [];

  return Object.keys(cart)
    .filter((id) => {
      const quantity = cart[id];
      if (!quantity || quantity <= 0) return false;
      return !isValidDiscount(sconto?.[id]);
    })
    .map((id) => {
      const key = normalizeProductKey(id);
      const element = elementsMap.get(key);
      const name = element?.name || "Prodotto non trovato";
      const code = element?.sku || element?.id || id;
      const category =
        typeof element?.division !== "undefined" ? divisionNames[element.division] || String(element.division) : "N/D";
      return {
        cartId: id,
        name,
        code,
        category,
      };
    });
};

export const buildMissingDiscountMessage = (invalidProducts) => {
  if (!invalidProducts || invalidProducts.length === 0) return "";
  return `Impossibile inviare la richiesta: i seguenti prodotti richiedono l'impostazione dello sconto: ${invalidProducts
    .map((p) => `${p.name} (codice: ${p.code}, categoria: ${p.category})`)
    .join("; ")}`;
};

export const getDiscountsByDivision = (discountsValues, divisionId, currentSku) => {
  if (!Array.isArray(discountsValues)) return [];
  const division = Number(divisionId);
  if (!Number.isFinite(division)) return [];

  const sku = typeof currentSku === "undefined" || currentSku === null ? null : String(currentSku);

  const matchingDivision = discountsValues.filter((d) => Number(d?.division) === division);
  if (matchingDivision.length === 0) return [];

  const skuSpecific = sku
    ? matchingDivision.filter((d) => typeof d?.sku !== "undefined" && d.sku !== null && String(d.sku) === sku)
    : [];

  const baseList =
    skuSpecific.length > 0 ? skuSpecific : matchingDivision.filter((d) => typeof d?.sku === "undefined" || d.sku === null);

  const values = baseList.map((d) => Number(d?.discountValue)).filter((v) => Number.isFinite(v));

  const unique = Array.from(new Set(values));
  unique.sort((a, b) => a - b);
  return unique;
};

export const validateDiscountsValuesJson = (json) => {
  if (!Array.isArray(json)) {
    throw new Error("discountsValues deve essere un array");
  }

  return json
    .filter((row) => row && typeof row === "object")
    .filter((row) => {
      const division = Number(row.division);
      const discountValue = Number(row.discountValue);
      if (!Number.isInteger(division)) return false;
      if (!Number.isInteger(discountValue)) return false;
      if (discountValue < 0 || discountValue > 100) return false;
      if (typeof row.sku !== "undefined" && row.sku !== null && !Number.isFinite(Number(row.sku))) return false;
      return true;
    })
    .map((row) => ({
      division: Number(row.division),
      discountValue: Number(row.discountValue),
      ...(typeof row.sku !== "undefined" && row.sku !== null ? { sku: Number(row.sku) } : {}),
    }));
};
